import * as e from "react";
import { useState as t, useEffect as n } from "react";
import { Row as r, Col as l, Form as a, Container as o } from "react-bootstrap";
import { IoIosClose as c } from "react-icons/io";
import { WmkLink as s } from "wmk-link";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _i = function i() {
  return _i = Object.assign || function (e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      for (var l in t = arguments[n]) {
        Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
      }
    }

    return e;
  }, _i.apply(this, arguments);
},
    u = function u(e) {
  var t = Object.keys(e).reduce(function (t, n) {
    return e[n].edges.forEach(function (e) {
      var r = _i({}, e.node);

      t.push({
        nodeType: n,
        node: r
      });
    }), t;
  }, []);
  this.index = t;
},
    m = function m(e, t, n, r) {
  return void 0 === n && (n = ""), void 0 === r && (r = "wmk"), [r + "-" + t, r + "-" + t + "-" + e, n].join(" ").trim();
},
    h = function h(t) {
  var n = t.result;
  return e.createElement(s, {
    to: n.to,
    target: n.target
  }, n.text);
},
    f = function f() {
  return e.createElement(c, null);
},
    p = function p(e, t, n, r) {
  var l = n.index,
      a = e.target.value;
  t(a), r(l.filter(function (e) {
    var t = e.node.title,
        n = new RegExp(a, "i");
    return Array.isArray(t.match(n));
  }));
},
    d = function d(c) {
  var s = c.isSearchOpen,
      d = c.setIsSearchOpen,
      E = c.query,
      y = c.Result,
      v = c.CloseIcon,
      g = c.className,
      x = c.style,
      w = c.useAlgorithm,
      N = c.resultConversion,
      b = t(),
      C = b[0],
      j = b[1],
      k = t([]),
      O = k[0],
      S = k[1],
      I = t(""),
      A = I[0],
      H = I[1],
      P = _i(_i({}, x), {
    position: s ? "fixed" : "absolute",
    zIndex: s ? 2e4 : -1,
    width: s ? "100%" : "1px",
    minHeight: s ? "100%" : "none",
    height: s ? "auto" : "1px",
    transition: "all 0.3s ease",
    right: 0,
    top: 0,
    overflow: s ? "scroll" : "hidden"
  }),
      R = function R(t) {
    var n = t.result;
    return y ? e.createElement(y, {
      result: n
    }) : e.createElement(h, {
      result: n
    });
  },
      T = v || f,
      q = w || p,
      z = function z() {
    d(!1), H("");
  },
      D = [];

  return D.push(s ? "search-open" : "search-closed"), D.push(g), n(function () {
    j(new u(E));
  }, []), e.createElement("div", {
    style: P,
    className: m("drawer", "search", D.join(" "))
  }, e.createElement(r, {
    className: "flex-column",
    style: {
      width: "100%"
    }
  }, e.createElement(l, {
    style: {
      width: "100%",
      display: "flex",
      justifyContent: "flex-end",
      padding: "2vh 3vw",
      minHeight: "5rem"
    }
  }, e.createElement("button", {
    onClick: z,
    "aria-label": "Close Search",
    className: "close"
  }, e.createElement(T, null))), e.createElement(l, {
    style: {
      display: "flex",
      justifyContent: "center",
      minHeight: "5rem"
    }
  }, e.createElement(a, {
    style: {
      width: "80%"
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();
    },
    className: "search-form"
  }, e.createElement(a.Control, {
    placeholder: "Enter Search...",
    onChange: function onChange(e) {
      q(e, H, C, S);
    },
    value: A
  }))), e.createElement(l, {
    className: "results"
  }, e.createElement(o, null, e.createElement(r, {
    style: {
      maxWidth: "80%",
      margin: "auto"
    },
    className: "flex-column"
  }, O && O.length > 0 && "" !== A ? O.map(function (t, n) {
    return e.createElement(l, {
      key: t.nodeType + n,
      onClick: z
    }, e.createElement(R, {
      result: N(t)
    }));
  }) : O && O.length < 1 && "" !== A ? e.createElement(l, {
    className: "no-result"
  }, e.createElement("em", null, "No results matching ", e.createElement("strong", null, A), "."), e.createElement("p", null, e.createElement("sub", null, "Please try another search."))) : null)))));
},
    E = function E(t) {
  var n = t.isSearchOpen,
      r = t.setIsSearchOpen,
      l = t.className,
      a = t.children,
      o = t.style,
      c = [];
  return c.push(n ? "search-open" : "search-closed"), c.push(l), e.createElement("button", {
    className: m("open", "search", c.join(" ")),
    onClick: function onClick() {
      r(!0);
    },
    style: o || void 0
  }, a);
};

export { u as SearchIndex, d as SearchSliderDrawer, E as SearchSliderOpen };